import { SERVICE_TYPES } from "@routebot/constants";
import { CheckTimeString } from "shared/util/time";
import { findUserInServices } from "shared/util/relationaldata";

export const createTransferAnalyzerHandlers = ({
  t,
  users,
  services,
  usersInTheTransfer,
  setUsersInTheTransfer,
  school,
  transfer,
  type,
  updateUsersInTheService,
  updateUsersDetailsInTheService,
  addService,
  deleteService,
  updateVehicleRoutesInTheTransfer,
  sendFreeSms,
  UpdatePersonelService,
  InsertPersonelService,
  DeletePersonelService,
  UpdateTransfer,
}) => {
  const updateUsersInTheServiceHandler = async (serviceId, newUsers) => {
    if (!serviceId) {
      return false;
    }
    const newPersonelService = await updateUsersInTheService(serviceId, newUsers);
    if (newPersonelService) {
      UpdatePersonelService(newPersonelService);
      return true;
    }
    return false;
  };

  const changeUserServiceHandler = async (userId, serviceId) => {
    const user = users.find((u) => u.id === userId);
    if (!user) return false;

    const currentUserService = findUserInServices(services, userId);

    if (currentUserService?.id === serviceId) return true;

    let success = false;

    if (currentUserService) {
      currentUserService.users = currentUserService.users.filter((u) => u.id !== userId);
      success = await updateUsersInTheServiceHandler(
        currentUserService.id,
        currentUserService.users.map((u) => u.id)
      );
      if (!success) return false;
    }

    if (serviceId) {
      const targetService = services.find((service) => service.id === serviceId);
      if (!targetService) return false;

      targetService.users.push(user);
      success = await updateUsersInTheServiceHandler(
        targetService.id,
        targetService.users.map((u) => u.id)
      );
    } else {
      success = true;
    }

    if (success) {
      window.toast.success(t("updateSuccess"));
    }
    return success;
  };

  const addPersonelHandler = async (personelId) => {
    if (!usersInTheTransfer.map((user) => user.id).includes(personelId)) {
      const user = users.find((item) => item.id === personelId);
      setUsersInTheTransfer([user, ...usersInTheTransfer]);
    }
  };

  const removePersonelHandler = async (personelId) => {
    const success1 = await changeUserServiceHandler(personelId, null);
    if (success1) {
      setUsersInTheTransfer(usersInTheTransfer.filter((user) => user.id !== personelId));
    }
  };

  const updateUsersDetailsInTheServiceHandler = async (serviceId, usersdetails) => {
    if (!serviceId || !usersdetails || !usersdetails.length) {
      return;
    }
    const personelservice = await updateUsersDetailsInTheService(serviceId, usersdetails);
    if (personelservice) {
      UpdatePersonelService(personelservice);
      return true;
    }
    return false;
  };

  const changeUserTransferTimeHandler = async (userId, transferTime) => {
    if (transferTime === null || transferTime === undefined) {
      return;
    }
    if (transferTime?.length) {
      if (!CheckTimeString(transferTime)) {
        window.toast.error("Lütfen geçerli bir saat giriniz. Örnek: 21:30");
        return;
      }
    }

    const user = users.find((item) => item.id === userId);
    const newServicesIntheShift = [...services];
    if (user) {
      const currentUserService = newServicesIntheShift.find((service) =>
        service.users?.map((u) => u.id).includes(userId)
      );
      if (currentUserService) {
        const currentUsersDetails = currentUserService.usersdetails;
        const currentUserDetails = currentUsersDetails.find((userdetail) => userdetail?.user === userId);
        const currentUserTransferTime = currentUserDetails?.transfertime;
        if (currentUserTransferTime && currentUserTransferTime === transferTime) {
          return;
        }
        if (transferTime) {
          if (!currentUserDetails) {
            currentUserService.usersdetails.push({ user: userId, transfertime: transferTime, smses: [] });
          } else {
            currentUserDetails.transfertime = transferTime;
          }
        } else if (
          (transferTime === null || transferTime === undefined || transferTime === "") &&
          currentUserTransferTime
        ) {
          if (!currentUserDetails) {
            currentUserService.usersdetails.push({ user: userId, transfertime: "", smses: [] });
          } else {
            currentUserDetails.transfertime = "";
          }
        } else {
          return;
        }

        const success = await updateUsersDetailsInTheServiceHandler(currentUserService.id, currentUsersDetails);
        if (success) {
          window.toast.success(t("updateSuccess"));
        }
      }
    }
  };

  const sendSMSHandler = async (service, userId, text) => {
    const foundService = findUserInServices(services, userId);
    if (!foundService) {
      return;
    }

    const user = users.find((item) => item.id === userId);
    const phone = user.phonenumber;

    const sendSms = await sendFreeSms(phone, text);

    if (sendSms) {
      const currentUsersDetails = [...service.usersdetails];
      const currentUserDetails = currentUsersDetails.find((userdetail) => userdetail?.user === userId);
      if (!currentUserDetails) {
        service.usersdetails.push({ user: userId, transfertime: "", smses: [sendSms] });
      } else {
        currentUserDetails.smses.push(sendSms);
      }

      await updateUsersDetailsInTheServiceHandler(
        service.id,
        service.usersdetails.map((userdetail) => {
          if (userdetail.user === userId) {
            return currentUserDetails;
          }
          return userdetail;
        })
      );

      window.toast.success(t("Sms gönderildi."));
    }
  };

  // Toplu gönderim iki fazda çalışır:
  // Faz 1: SMS'ler 5'erli gruplar halinde PARALEL gönderilir (usersdetails'e dokunulmaz).
  // Faz 2: Gönderilen SMS'ler servise göre gruplanır ve her servisin usersdetails'i
  //        SERVİS BAŞINA TEK PATCH ile SIRALI olarak güncellenir.
  // Faz 2 sıralı olduğu için aynı servisin usersdetails dizisine eşzamanlı yazım
  // (lost update / race condition) oluşamaz.
  const SEND_ALL_SMS_BATCH_SIZE = 5;

  const sendAllSMSHandler = async (messageContexts) => {
    const sentItems = [];

    for (let i = 0; i < messageContexts.length; i += SEND_ALL_SMS_BATCH_SIZE) {
      const batch = messageContexts.slice(i, i + SEND_ALL_SMS_BATCH_SIZE);
      const batchResults = await Promise.allSettled(
        batch.map(async ({ service, userId, text }) => {
          const foundService = findUserInServices(services, userId);
          if (!foundService || !service) {
            return null;
          }
          const user = users.find((item) => item.id === userId);
          if (!user) {
            return null;
          }
          const sms = await sendFreeSms(user.phonenumber, text);
          return sms ? { service, userId, sms } : null;
        })
      );
      for (const result of batchResults) {
        if (result.status === "fulfilled" && result.value) {
          sentItems.push(result.value);
        }
      }
    }

    if (sentItems.length === 0) {
      return;
    }

    const groupedByService = new Map();
    for (const item of sentItems) {
      if (!groupedByService.has(item.service.id)) {
        groupedByService.set(item.service.id, { service: item.service, items: [] });
      }
      groupedByService.get(item.service.id).items.push(item);
    }

    for (const { service, items } of groupedByService.values()) {
      if (!service.usersdetails) {
        service.usersdetails = [];
      }
      for (const { userId, sms } of items) {
        const currentUserDetails = service.usersdetails.find((userdetail) => userdetail?.user === userId);
        if (!currentUserDetails) {
          service.usersdetails.push({ user: userId, transfertime: "", smses: [sms] });
        } else if (!currentUserDetails.smses) {
          currentUserDetails.smses = [sms];
        } else {
          currentUserDetails.smses.push(sms);
        }
      }
      await updateUsersDetailsInTheServiceHandler(service.id, service.usersdetails);
    }

    window.toast.success(t("Sms gönderildi."));
  };

  const addServiceHandler = async (name, drivers, plate, starttime, stoptime, routeClientArrivalTime) => {
    const infoToBeSent = {
      school: school.id,
      type: type,
      serviceType: SERVICE_TYPES.TRANSFER_PERSONEL,
      date: transfer.transferdate,
      users: [],
      isshift: false,
      status: 1,
      name: name,
      drivers: drivers,
      plate: plate,
      starttime: "00:00",
      stoptime: "23:59",
      routeClientArrivalTime: routeClientArrivalTime || undefined,
    };
    const newPersonelService = await addService(infoToBeSent);
    const updatedTransfer = await updateVehicleRoutesInTheTransfer(transfer.id, [
      ...transfer.vehicleRoutes,
      newPersonelService.id,
    ]);
    if (newPersonelService && updatedTransfer) {
      InsertPersonelService(newPersonelService);
      UpdateTransfer(updatedTransfer);
      window.toast.success(t("updateSuccess"));
    }
  };

  const deleteServiceHandler = async (serviceId) => {
    const success = await deleteService(serviceId);
    if (success) {
      DeletePersonelService(serviceId);
      updateVehicleRoutesInTheTransfer(
        transfer.id,
        transfer.vehicleRoutes.filter((route) => route !== serviceId)
      );
      UpdateTransfer({ ...transfer, vehicleRoutes: transfer.vehicleRoutes.filter((route) => route !== serviceId) });
      window.toast.success(t("updateSuccess"));
    }
  };

  return {
    updateUsersInTheServiceHandler,
    changeUserServiceHandler,
    addPersonelHandler,
    removePersonelHandler,
    changeUserTransferTimeHandler,
    sendSMSHandler,
    sendAllSMSHandler,
    addServiceHandler,
    deleteServiceHandler,
  };
};
